import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import SevenWaysCC from "assets/images/psp/7-ways-cc.webp";
import CCvsOtherStorage from "assets/images/psp/cc-vs-other-storage.webp";
import WhatNeedsCC from "assets/images/psp/what-needs-cc.webp";
import HeaderBackgroundDesktop from "assets/images/psp/hero/climate-controlled-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/climate-controlled-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/climate-controlled-header-tablet.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const Storagesizechartdata = [
	{
		title: "5x5",
		description: "Average Monthly Cost: $35.96",
		numerics: ["25 ft²", "200 ft³"]
	},
	{
		title: "5x10",
		description: "Average Monthly Cost: $54.93",
		numerics: ["50 ft²", "400 ft³"]
	},
	{
		title: "5x15",
		description: "Average Monthly Cost: $87.24",
		numerics: ["75 ft²", "600 ft³"]
	},
	{
		title: "10x10",
		description: "Average Monthly Cost: $88.82",
		numerics: ["100 ft²", "800 ft³"]
	},
	{
		title: "10x15",
		description: "Average Monthly Cost: $129.83",
		numerics: ["150 ft²", "1200 ft³"]
	},
	{
		title: "10x20",
		description: "Average Monthly Cost: $160.64",
		numerics: ["200 ft²", "1600 ft³"]
	},
	{
		title: "10x30",
		description: "Average Monthly Cost: $226.77",
		numerics: ["300 ft²", "2400 ft³"]
	}
];

const reviews = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: 'Great experience with my storage! I love the "drive right in" climate-controlled storage area. Staff was super helpful with telling me about the system they use and setting me up.',
			author: "Jachooz",
			title: "Great experience with my storage",
			imageSrc: GeorgeRansom
		},
		{
			body: "Very knowledgeable and detail-oriented. The storage facility the Storage.com rep recommended is very close to where I live and at a reasonable rate. Climate-controlled and state-of-the-art security, which I can appreciate. Thanks again for all of your help and information.",
			author: "C. Meredith",
			title: "Excellent Customer Service",
			imageSrc: AnnAlarcon
		},
		{
			body: "I had never used a storage unit before and had many questions regarding the necessary size, locations, climate-controlled, etc. Storage.com’s rep made sure all of my questions were answered and the reservation was made.",
			author: "Hilary Martin",
			title: "Excellent help when I needed it!",
			imageSrc: SMurphy
		}
	]
};

const faqs = [
	{
		question: "Do I need climate control for vehicle storage?",
		answer: "If you are planning to store your vehicle long-term, especially in areas with extreme temperatures or high humidity, climate control is essential to protect your vehicle. A stable temperature and humidity level will help protect your vehicle’s interiors and electronics from damage."
	},
	{
		question:
			"Is climate-controlled storage more expensive than standard units?",
		answer: "Yes, climate-controlled units typically [cost more than standard units](https://storage.com/blog/long-term-storage-cost/) due to the added protection. However, the added cost can save you money in the long run by reducing damage to valuable items. Storage.com’s search tool lets you compare unit rates to find the best deal before you commit."
	},
	{
		question: "What types of business items need climate control?",
		answer: "Businesses often use climate-controlled storage for records, inventory, electronics, and equipment. Regulated temperature and stable humidity levels help prevent warping, rust, or spoilage."
	},
	{
		question: "What types of climate-controlled storage are available?",
		answer:
			"Climate-controlled storage units generally [fall into three categories](https://storage.com/blog/what-is-climate-controlled-storage/):\n" +
			" - **Climate-controlled storage unit:** Your storage unit is kept within 55-80°F\n" +
			" - **Air-conditioned or heated storage unit:** The unit’s temperature is adjusted by adding hot or cool air.\n" +
			" - **Humidity-controlled storage unit:** The unit regulates moisture by keeping humidity levels around 55%"
	},
	{
		question:
			"Can I access my climate-controlled storage unit after business hours?",
		answer: "Many facilities offer [24-hour access](https://storage.com/blog/benefits-of-24-hour-storage/) to indoor climate-controlled units, but policies vary. Use Storage.com’s search filters to find units with 24/7 access and check with the facility to confirm access hours and restrictions."
	}
];

const relatedContentCards = [
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/climate-controlled-storage-units/",
		date: "December 1, 2025",
		image: SevenWaysCC,
		content: "Seven Ways to Use Climate Controlled Storage"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/climate-controlled-storage-vs-non-climate-controlled/",
		date: "March 25, 2025",
		image: CCvsOtherStorage,
		content:
			"Climate Controlled Storage vs Non Climate Controlled Storage - Which One is Right for You?"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/what-is-climate-controlled-storage/",
		date: "March 9, 2025",
		image: "https://www.storage.com/blog/wp-content/uploads/2024/11/aircontrol-jpg.webp",
		content: "Climate Controlled vs Air Cooled and Heated Storage"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/10-items-that-need-climate-controlled-storage/",
		date: "March 9, 2025",
		image: WhatNeedsCC,
		content: "What Needs Climate-Controlled Storage"
	}
];

const climateHerodescription = `
Some items can’t handle extreme temperature or humidity—think antique furniture, business documents, vehicles, or seasonal gear. That’s where climate-controlled storage comes in. These indoor units offer extra protection by maintaining a consistent temperature between 55°F and 85°F and a stable humidity level.\n\n
Whether you’re storing household items during a move or keeping inventory for your business, Storage.com makes it easy to find a climate-controlled storage unit to keep your belongings protected year-round.
`;

export const PSPClimateControlledContent = {
	type: "Climate Controlled",
	sections: [
		{
    title: "Climate Control hero",
    noPadding: true,
    modules: [
        {
            type: "hero-section",
            props: {
                title: "Find the Top Climate Control Storage Units",
                description: climateHerodescription,
                searchPlaceholder: "Search by city, state, or zip...",
                buttonText: "Find Climate Control Storage",
				heroImages: {
					desktop: HeaderBackgroundDesktop,
					tablet: HeaderBackgroundTablet,
					mobile: HeaderBackgroundMobile
				},
				heroAltText: "Climate Control Storage Hero Image"
            }
        }
    ]
},
		{
			title: "Climate Controlled Storage",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "Is Climate Control Right for You?",
						description:
							"Not all items store well in a standard unit, especially with extreme temperature swings or humidity. Understanding which of your belongings will thrive in climate controlled storage versus traditional storage will help you make the right choice.",
						mediaType: "video",
						mediaUrl: "3P_-fzKRpZ0",
						videoTitle: "Is Climate Control Right for You?"
					}
				}
			]
		},
		{
			title: "Climate controlled content module",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Climate Controlled Storage for Commercial and Personal Use ",
						background: "white",
						content: [
							{
								id: "1",
								value: "Climate controlled storage is a great choice for commercial storage and personal storage purposes. With a variety of storage unit sizes to choose from, you can create a temperature controlled environment from everything to treasured family heirlooms to business archives and excess office furniture."
							},
							{
								id: "2",
								value: "For personal use, it’s ideal to protect sensitive items such as furniture, electronics, photographs, and family heirlooms from warping or mold. Decorations, clothing, and other seasonal items also last longer in a climate-controlled environment."
							},
							{
								id: "3",
								value: "For business use, it’s crucial to protect important documents, inventory, and equipment that are susceptible to heat, cold, and humidity."
							},
							{
								id: "4",
								value: "Storage.com’s search tool lets you compare facilities and find temperature-controlled storage units near you that fit your storage needs and budget."
							}
						],
						isColumnWise: false,
					}
				}
			]
		},
		{
			title: "Climate controlled storage size chart",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						title: "Climate-Controlled Storage Cost by Unit Size",
						background: "light-blue",
						description:
							"The climate controlled storage unit cost chart below will help you understand average costs for different size storage units.",

						storages: Storagesizechartdata
					}
				}
			]
		},
		{
			title: "Climate Controlled Storage",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Climate Controlled"
					}
				}
			]
		},
		{
			title: "Climate Controlled Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},
		{
			title: "Climate Controlled Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Climate Controlled Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "Climate Controlled Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Climate Control Storage",
						background: "light-blue",
						unitCards: relatedContentCards
					}
				}
			]
		},
		{
			title: "Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							storageTypes: storageCategories.climate
						}
					}
				}
			]
		},
		{
			title: "Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue",
					}
				}
			]
		}
	]
};

export default PSPClimateControlledContent;
